module.exports = __webpack_public_path__ + "static/media/profile_pic.3a8f5460.png";